import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapSearchService {
  private service: google.maps.places.PlacesService = new google.maps.places.PlacesService(new google.maps.Map(window.document.createElement("div") as HTMLElement));
  private autoCompleteService: google.maps.places.AutocompleteService = new google.maps.places.AutocompleteService();
  constructor() { }

  textSearch(query: string, types: string[], countries: string[] | null) {
    const sub: Subject<google.maps.places.AutocompletePrediction[]> = new Subject<google.maps.places.AutocompletePrediction[]>();
    this.autoCompleteService.getPlacePredictions({input: query, types, componentRestrictions: countries ? {country: countries} : null}, (a: google.maps.places.AutocompletePrediction[], b: google.maps.places.PlacesServiceStatus) => b === google.maps.places.PlacesServiceStatus.OK || b === google.maps.places.PlacesServiceStatus.ZERO_RESULTS  ? sub.next(a || []) : sub.error(null));
    return sub;
  }

  getPlaceDetails(placeId: string, fields: string[]) {
    const sub: Subject<google.maps.places.PlaceResult> = new Subject<google.maps.places.PlaceResult>();
    this.service.getDetails({placeId, fields}, (a: google.maps.places.PlaceResult, b: google.maps.places.PlacesServiceStatus) => b === google.maps.places.PlacesServiceStatus.OK ? sub.next(a) : sub.error(null));
    return sub;
  }
}
